import { render, staticRenderFns } from "./addressPop.vue?vue&type=template&id=21ef7a7e&scoped=true"
import script from "./addressPop.vue?vue&type=script&lang=js"
export * from "./addressPop.vue?vue&type=script&lang=js"
import style0 from "./addressPop.vue?vue&type=style&index=0&id=21ef7a7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef7a7e",
  null
  
)

export default component.exports